import Vue from "vue";
import Router from "vue-router";

// 랜딩페이지
import ViewPc from "@/page/PcView";
// 솔닥
import PcContainer from "@/page/PcContainer";
// 파트너스
import PcPartners from "@/page/PcPartners";
// 바로돌봄 New [2024.05.16]
import PcBarocareNew from "@/page/PcBarocareNew";
// 바로돌봄 B2C [2024.07.08]
import PcbarocareB2c from "@/page/Pcbarocareb2c";
// 솔닥 컨시어지 메인 [2024.12.13]
import PcbarocareConci from "@/page/concierge/pc/PcBarocareConci";
// 솔닥 컨시어지 서브 [2024.12.13]
import PcBarocareSub1 from "@/page/concierge/pc/PcBarocareSub1";
import PcBarocareSub2 from "@/page/concierge/pc/PcBarocareSub2";
import PcBarocareSub3 from "@/page/concierge/pc/PcBarocareSub3";
import PcBarocareSub4 from "@/page/concierge/pc/PcBarocareSub4";
import PcBarocareSub5 from "@/page/concierge/pc/PcBarocareSub5";


Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        { path: "/", redirect: '/barocarenew' },
        {
            path: "/barocarenew",
            name: "barocarenew",
            component: PcbarocareConci,
            children: [
                {
                    path: "sub1",
                    name: "barocarenew-sub1",
                    component: PcBarocareSub1,
                },
                {
                  path: "sub2",
                  name: "barocarenew-sub2",
                  component: PcBarocareSub2,
                },
                {
                  path: "sub3", 
                  name: "barocarenew-sub3",
                  component: PcBarocareSub3,
                },
                {
                  path: "sub4",
                  name: "barocarenew-sub4",
                  component: PcBarocareSub4,
                },
                {
                  path: "sub5",
                  name: "barocarenew-sub5",
                  component: PcBarocareSub5,
                },
            ],
        },

        // { path: "/", redirect: '/barocarenew' },
        // {
        //     path: "/barocarenew",
        //     name: "barocarenew",
        //     component: MobileBarocareConci,
        //     children: [
        //         {
        //             path: "sub1", 
        //             name: "barocarenew-sub2",
        //             component: MobileBarocareSub1,
        //         },
        //         {
        //           path: "sub2", 
        //           name: "barocarenew-sub2",
        //           component: MobileBarocareSub2,
        //         },
        //         {
        //           path: "sub3", 
        //           name: "barocarenew-sub3",
        //           component: MobileBarocareSub3,
        //         },
        //         {
        //           path: "sub4", 
        //           name: "barocarenew-sub4",
        //           component: MobileBarocareSub4,
        //         },
        //         {
        //           path: "sub5", 
        //           name: "barocarenew-sub5",
        //           component: MobileBarocareSub5,
        //         },
        //     ],
        // },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js